import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useDayforceWebhooksContextValue } from '../context/DayforceWebhooksProvider'

export const DayforceWebhooksHeader = () => {
  const { state, actions } = useDayforceWebhooksContextValue()

  return (
    <Header
      title="Dayforce Webhooks"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
